export enum JOB_STATE {
  ENQUEUED = 'Enqueued',
  RUNNING = 'Running',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
  CANCELLING = 'Cancelling',
}

export enum JOB_TYPE {
  EXPORT_JOB = 'ExportJobData',
  TEST_JOB = 'TestJob',
  USER_RECORD_ANALYSIS_JOB = 'UserRecordAnalysisJobData',
}
